import React from 'react'
import { Input, Button, Modal, Form } from 'antd'
import PropTypes from 'prop-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorMessage, successMessage } from 'services/messager'
import { createNewTeam } from 'services/demands/teamsServices'

const TeamModal = ({ handleCancel, showModal }) => {
	const queryClient = useQueryClient()
	const [form] = Form.useForm()

	const { mutate: handleCreateTeam, isPending: isLoadingNewTeam } = useMutation(
		{
			mutationFn: async () => {
				const values = form.getFieldsValue()

				if (!values?.teamName) {
					throw new Error('Missing team name')
				}

				const data = await createNewTeam(values.teamName)

				return data
			},
			onSuccess: () => {
				successMessage({
					content: 'Novo time criado com sucesso!',
				})
				queryClient.invalidateQueries({ queryKey: ['team-options'] })
				handleCancel()
			},
			onError: (error) => {
				console.log(error)
				errorMessage({
					content: 'Erro ao criar novo time.',
				})
			},
		}
	)

	return (
		<Modal
			open={showModal}
			onCancel={handleCancel}
			footer={[
				<Button key="cancelar" onClick={handleCancel}>
					Cancelar
				</Button>,
				<Button
					key="criar"
					onClick={handleCreateTeam}
					form="newTeamForm"
					disabled={isLoadingNewTeam}>
					Criar
				</Button>,
			]}>
			<Form form={form} id="newTeamForm">
				<Form.Item label="Novo Time"></Form.Item>
				<Form.Item label="Nome" name="teamName">
					<Input name="teamName" />
				</Form.Item>
			</Form>
		</Modal>
	)
}

TeamModal.propTypes = {
	handleCancel: PropTypes.func,
	showModal: PropTypes.bool,
}

export default TeamModal
